import { PolitischeGemeindeId } from '../../../core/av-api';
import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PolitischeGemeindeListEntry, StammdatengemeindeService } from '../../../core/stammdaten-api';
import { PolitischeGemeindeSearchmode } from './politische-gemeinde-searchmode';
import { Subscription } from 'rxjs';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { AbstractTypeaheadSearch } from '../../components/typeahead-search/abstract-typeahead-search';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-pol-gemeinde',
  templateUrl: './pol-gemeinde.component.html',
  styleUrls: ['./pol-gemeinde.component.scss'],
  host: {
    class: 'form-control-component'
  },
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PolGemeindeComponent), multi: true }],
  imports: [FormsModule, NgbTypeahead, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class PolGemeindeComponent
  extends AbstractTypeaheadSearch<PolitischeGemeindeListEntry>
  implements OnInit, AfterViewInit, ControlValueAccessor, OnDestroy
{
  @Input()
  searchMode: PolitischeGemeindeSearchmode;

  @Input()
  hasfocus = false;

  @Input()
  requestMode: 'NUR_GUELTIGE_GEMEINDEN' | 'NUR_NICHT_GUELTIGE_GEMEINDEN' | 'ALLE' = 'ALLE';

  gemeindeModel: PolitischeGemeindeListEntry;
  minSearchLength = 2;

  propagateChange: (id: PolitischeGemeindeId) => void;
  propagateTouch: (_) => void;

  private reset = false;
  private subscription: Subscription;

  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  constructor(private polGemeindeService: StammdatengemeindeService) {
    super();
  }

  ngOnInit() {
    const findAll = this.polGemeindeService.loadGemeindeAll(
      //
      PolitischeGemeindeSearchmode[this.searchMode],
      this.requestMode,
      true
    );
    this.setSearch(findAll);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.hasfocus) {
        this.searchInput.nativeElement.focus();
      }
    });
  }

  onBlur() {
    if (!this.gemeindeModel) {
      this.value = '';
      this.propagateChange(null);
    }
  }

  writeValue(id: PolitischeGemeindeId): void {
    if (id) {
      this.subscription = this.polGemeindeService.loadGemeinde(id.id).subscribe((gemeinde) => {
        this.value = this.formatEntry(gemeinde);
        this.selectedItem = gemeinde;
        this.gemeindeModel = gemeinde;
        if (this.propagateChange) {
          this.propagateChange(gemeinde.id);
        }
      });
      this.reset = false;
    } else if (!this.reset) {
      this.reset = true;
      this.onClear();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  onSelected($event: NgbTypeaheadSelectItemEvent<PolitischeGemeindeListEntry>) {
    const selectedItem: PolitischeGemeindeListEntry = $event.item;
    if (selectedItem) {
      this.selectedItem = selectedItem;
      this.reset = false;
      this.value = this.formatEntry(selectedItem);
      this.gemeindeModel = selectedItem;
      if (this.propagateChange) {
        this.propagateChange(selectedItem.id);
      }
    }
  }

  formatEntry(entry: PolitischeGemeindeListEntry): string {
    if (entry?.name && entry?.bfsNummer) {
      return entry.name + ' ' + entry.bfsNummer;
    }
    return '';
  }

  public onClear() {
    super.onClear();
    this.gemeindeModel = null;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
